import '../assets/css/styles.css'
import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginMain from './login-main-component/LoginMainComponent.vue'
import GamesContainer from './games-container-component/GamesContainerComponent.vue'
import injector from 'vue-inject';
import * as uiv from 'uiv'


//import BootstrapVue from 'bootstrap-vue'

console.log('LOADING...');
Vue.use(VueRouter);
Vue.use(injector);
Vue.use(uiv);
//Vue.use(BootstrapVue);

const routes = [
    {path: "/games", component: GamesContainer},
    {path: "/", component: LoginMain}
];

const router = new VueRouter({
    mode: 'history',
    base: `/${settings.applicationName}/`,
    routes
});

new Vue({
    el: '#main',
    router
});